<div
  *ngIf="item"
  [class.blocked]="item.is_blocked"
  [style]="{ backgroundColor: item.color }"
  class="card">
  <div class="card__line">
    <div class="card__line-left">
      <img
        *ngIf="item.is_main && !item.is_blocked"
        src="assets/img/main-card.svg"
        alt="Star"
        class="icon" />
      <img
        *ngIf="!item.is_main && !item.is_blocked"
        src="assets/img/active-card.svg"
        alt="Star"
        class="icon" />
      <img
        *ngIf="item.is_blocked"
        src="assets/img/blocked-card.svg"
        alt="Star"
        class="icon" />

      <p
        *ngIf="item.bank_name"
        class="bank-name">
        {{ item.bank_name }}
      </p>
    </div>
    <div
      *ngIf="isEditable"
      class="card__line-right">
      <app-context-menu
        [position]="'left'"
        [color]="'white'">
        <app-saved-card-context-menu
          (deleteCardEvent)="deleteCard($event)"
          [item]="item">
        </app-saved-card-context-menu>
      </app-context-menu>
    </div>
  </div>
  <div class="card__line">
    <div class="card__line-number">
      <img
        src="assets/img/doter.svg"
        alt="Doter"
        class="doter" />
      <img
        src="assets/img/doter.svg"
        alt="Doter"
        class="doter" />
      <img
        src="assets/img/doter.svg"
        alt="Doter"
        class="doter" />
      <span>{{ item.card_num }}</span>
    </div>
  </div>
  <div class="card__line">
    <div class="card__line-left">
      <img
        *ngIf="item.payment_system === 'MASTERCARD'"
        src="assets/img/mc-card.svg"
        alt="Icon card"
        class="icon-card" />
      <img
        *ngIf="item.payment_system === 'VISA'"
        src="assets/img/visa-card.svg"
        alt="Icon card"
        class="icon-card" />
      <img
        *ngIf="item.payment_system === 'UNIONPAY'"
        src="assets/img/union-card.svg"
        alt="Icon card"
        class="icon-card" />
    </div>
    <div class="card__line-right">
      <p class="date">{{ item.validity.substring(0, 2) }}/{{ item.validity.substring(2, 4) }}</p>
    </div>
  </div>
</div>
